// Copyright (c) 2016 Deere & Company

import PipViews from '../../pip/shared/components/pip-views';

export default {
    component: PipViews,
    name: 'PIPS',
    path: 'pips'
};



// WEBPACK FOOTER //
// ./src/routes/pips/pips.js